import React from 'react';
import {Modal, Icon} from 'antd';
import {api, app, config} from '../../app';
import PayTemplate from '../../components/PayTemplate';

const FalseData = false;

const getParams = () => {
  return {
    indexno: app.getData('indexno'),
    account: app.getData('account'),
  };
};

/**
 * 购买保险表单信息
 * @returns {Promise<*>}
 */
export const getInsuranceOrgOrderFormDetail = async () => {
  const {flag, data, msg} = await app.post('/InsuranceOrg/orderFormDetail', getParams());
  if (flag === 1) {
    return data;
  } else {
    app.alert(msg, 'error', '45%');
    return {};
  }
};

/**
 * 获取支付路径
 * @returns {Promise<*>}
 */
export const getInsuranceOrgOrderPay = async (id, successCB) => {
  const {flag, data, msg} = await app.post('/InsuranceOrg/orderPay', {id, ...getParams()});
  if (flag === 1) {
    Modal.confirm({
      title: '手机扫码支付',
      centered: true,
      icon: (<Icon type="pay-circle" style={{color: '#FF8727'}}/>),
      width: 600,
      content: (
        <PayTemplate qrcode={data.url} generate={true} money={data.amount} no={data.cntr_no} terminal=" "/>),
      okText: '已支付',
      cancelText: '关闭',
      onOk: async () => {
        const res = await app.post('/InsuranceOrg/orderState', {...getParams(), id});
        if (res.flag === 1) {
          switch (String(res.data.state)) {
            case '0':
              app.alert('暂未查到支付信息', 'warn');
              return Promise.reject(false);
            case '2':
              app.alert('支付成功', 'success');
              successCB(true);
              break;
            case '3':
              app.alert('订单支付失败', 'warn');
              successCB(true);
              break;
            case '9':
              app.alert('订单已关闭', 'warn');
              successCB(true);
              break;
            default:
              app.alert('未知错误', 'warn');
              successCB(true);
              break;
          }
        } else {
          app.alert(res.msg, 'warn');
          return Promise.reject(false);
        }
      },
      onCancel: () => {
        successCB(false);
      }
    });
    return true;
  } else {
    app.alert(msg, 'error', '45%');
    return false;
  }
};

/**
 * 获取发票路径
 * @returns {Promise<*>}
 */
export const getInsuranceOrgInvoice = async (id) => {
  const {flag, data, msg} = await app.post('/InsuranceOrg/getInvoice', {id, ...getParams()});
  if (flag === 1) {
    return data;
  } else {
    app.alert(msg, 'error', '45%');
    return false;
  }
};

/**
 * 下单
 * @returns {Promise<*>}
 */
export const insuranceOrgOrderSubmit = async (params) => {
  params.return_url = config.insurePay;
  const {flag, data, msg} = await app.post('/InsuranceOrg/orderSubmit', {...getParams(), ...params});
  if (flag === 1) {
    app.alert(msg, 'success', '45%');
    return data.id;
  } else {
    app.alert(msg, 'error', '45%');
    return false;
  }
};


// WEBPACK FOOTER //
// ./src/routes/insure/insure_org_api.jsx